const getters = {
    addonProducts(state) {
        return state.addonProducts;
    },
    categories(state){
    return state.categories;
    },
    selectedCategory(state){
    return state.selectedCategory;
    },
    selectedCategoryMobile(state){
    return state.selectedCategoryMobile;
    },
    selectedSort(state){
    return state.selectedSort;
    },
    selectedSortMobile(state){
    return state.selectedSortMobile;
    },
    rangePrice(state){
    return state.rangePrice;
    },
    rangePriceMobile(state){
    return state.rangePriceMobile;
    },
};

export default getters;
